import React, { useEffect, useState } from 'react';
import { useAppSelector as useSelector } from 'hooks/reduxHooks';
import { Route, RouteComponentProps, useHistory, useParams } from 'react-router-dom';

import * as AuthActions from 'store/auth/auth.action';
import useActions from 'hooks/useActions';
import useFeatureFlag from 'hooks/useFeatureFlag';

type TPrivateRouterProps = {
  exact: boolean;
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<RouteComponentProps<any>> | React.FC<any>;
  requiredFlag?: string;
};

export default function PrivateRoute(props: TPrivateRouterProps) {
  const history = useHistory();
  const [hasRequiredFlags, setHasRequiredFlags] = useState(false);
  const authActions = useActions(AuthActions);
  const auth = useSelector((state) => state.auth);
  const featureFlag = useSelector((state) => state.featureFlag);
  const { flags } = useFeatureFlag();
  const { exact, path, component: RenderComponent, requiredFlag = '' } = props;
  const { pid: projectId } = useParams<{ pid: string }>();
  // authenticate user
  useEffect(() => {
    if (!auth?.authenticated) {
      authActions.authenticateUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // check if feature flag matches
  useEffect(() => {
    if (!featureFlag?.isInitialized) return;
    if (!requiredFlag) {
      setHasRequiredFlags(true);
    } else {
      if (flags?.[requiredFlag as keyof typeof flags]) {
        setHasRequiredFlags(true);
      } else {
        history.push(`/project/${projectId}/no-access`);
      }
    }
  }, [flags, requiredFlag, featureFlag?.isInitialized, projectId, history]);

  return auth?.authenticated && featureFlag?.isInitialized && hasRequiredFlags ? (
    <Route exact={exact} path={path} render={(props) => <RenderComponent {...props} />} />
  ) : (
    <></>
  );
}
